import { cx } from './cx.ts'

import './stage.css'

/**
 * 공정 칸의 막대 — 디자인팀 시안 2026-10-01 §2 「공정 진행」. 🔴 **두 곳이 같이 쓴다** — 모니터링 단계 카드
 * (`MonitoringScreen` `StageCard`)와 상시 작업 줄의 공정 칸(`shell/StripStages.tsx`).
 *
 * 🔴 **색만으로 말하지 않는다.** 바로 아래 줄이 같은 값을 숫자로 적고 있다(`3 / 5 · 60%`).
 *   - `ratio`(0~1)가 있으면 그만큼 채운다. ⚠ 어림·추정이 끼지 않는다 — 호출부가 두 수의 비로 만든 값뿐이다
 *   - 전체를 모르면(`pending`) 빗금 트랙 — 「집계 중」을 모양으로도 말한다(시안 §2)
 *   - 값이 없으면 빈 트랙(채움 0)
 * 상태별 색(강조 · 청회 · 주의 · 회색)은 부모의 `stage--*` 가 정한다 — 여기서 갈래를 두지 않는다.
 * 접근 이름(`label`)은 호출부가 만든다 — 단위(시료 · 스텝)가 자리마다 다르다.
 */
export function StageTrack({
  ratio,
  pending,
  label,
  className,
}: {
  /** 채움 0~1. 없으면 빈 트랙 */
  ratio?: number | undefined
  /** 전체를 모른다 — 빗금 트랙 */
  pending: boolean
  /** 스크린리더가 듣는 말 — 화면의 숫자와 같은 사실이어야 한다 */
  label: string
  className?: string | undefined
}) {
  const percent = ratio === undefined ? 0 : Math.min(100, Math.max(0, Math.round(ratio * 100)))
  return (
    <span
      aria-label={label}
      className={cx('stage__track', pending && 'stage__track--open', className)}
      role="img"
    >
      {pending ? null : (
        <span className="stage__fill" style={{ inlineSize: `${String(percent)}%` }} />
      )}
    </span>
  )
}
